import { Odin, Odim } from './components/odin/_core'
window.$odin = Odin
window.$odim = Odim
import './components/odin/_all'
